<mat-form-field
        [ngClass]="wrapperClasses"
        [appearance]="input.appearance"
        [floatLabel]="input.floatLabel" class="full-width">
    <mat-label>{{input.label}}</mat-label>
    <input
            #inputElement
            matInput
            [required]="input.required"
            [placeholder]="input.placeholder"
            [formControl]="searchControl"
            [aria-describedby]="inputElement.id + editPromptSuffix"
            (blur)="autoBlurEvent($event)"
            (focus)="autoFocusEvent($event)"
            [matAutocomplete]="auto">
    <mat-autocomplete #auto
                      (optionSelected)="selected($event)"
                      [displayWith]="renderDisplay.bind(this)">
        <mat-option *ngFor="let option of options" [value]="option">
            {{renderDisplay(option)}}
        </mat-option>
    </mat-autocomplete>
    <div class="loading-text" [hidden]="!loading">
        <mat-progress-spinner mode="indeterminate" color="primary" diameter="20"></mat-progress-spinner>
        Searching...
    </div>
    <div class="loading-text text-error" *ngIf="errorLoading">Error loading options!</div>
    <div class="loading-text text-error" *ngIf="noSearchResultsFound">Nothing found for your query!</div>
    <mat-error>{{errorMessage}}</mat-error>
    <mat-hint [ngClass]="hint?.class">{{hint?.message}}</mat-hint>
</mat-form-field>